import DOMPurify from "dompurify";
import { useState } from "react";

import { Alert, Heading, SpotIcon } from "@icg360/design-system";

import { RequestReset } from "components/request-reset/index.js";
import UnauthLayout from "components/shared/unauth-layout";

import styles from "./request-reset-page.module.scss";

const RequestResetPage = () => {
  const [errorMessages, setErrorMessages] = useState<string[]>([]);

  return (
    <UnauthLayout>
      <div className={styles.lockIcon}>
        <SpotIcon name="LockSecurity" />
      </div>
      <Heading size="lg">Reset password</Heading>
      {errorMessages.map((errorMessage, i) => (
        <Alert
          key={i}
          appearance="danger"
          title=""
          description={DOMPurify.sanitize(errorMessage)}
        />
      ))}

      <div>
        Enter the email address associated with your SageSure account. We will
        email you a password reset link.
      </div>

      <RequestReset setErrorMessages={setErrorMessages} />
    </UnauthLayout>
  );
};

export default RequestResetPage;
